import * as Yup from 'yup';
import { ITextControlField2 } from '../types';

export default function textFieldValidation(field: ITextControlField2) {
  let schema = Yup.string();
  if (field.is_mandatory) {
    schema = schema.required('This field is required').test({
      test: (value) => {
        if ((typeof value === 'string' && !value.trim()) || !value) {
          return false;
        }
        return true;
      },
      message: 'This is required'
    });
  }
  return {
    [field.name]: schema
  };
}
